import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { tokenLogin } from "~/api/authentication";
import { validateError } from "~/shared/utils/axiosErrorParser";
import { useAuthStore } from "~/stores";

interface UseTokenLoginOptions {
  onSuccess?: () => void;
  onError?: () => void;
}

export const useTokenLogin = (options: UseTokenLoginOptions = {}) => {
  const [searchParams] = useSearchParams();
  const setTokens = useAuthStore((state) => state.setTokens);

  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const [isLoggingIn, setIsLoggingIn] = useState(!!token && !!email);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorCode, setLoginErrorCode] = useState<string | null>(null);
  const loginAttempted = useRef(false);

  useEffect(() => {
    if (!token || !email || loginAttempted.current) {
      return;
    }

    loginAttempted.current = true;

    tokenLogin({ email, token })
      .then((response) => {
        setTokens(response.data.accessToken, response.data.refreshToken);
        options.onSuccess?.();
      })
      .catch((error: unknown) => {
        const parsedError = validateError(error);
        setIsLoggingIn(false);
        setLoginError(true);
        setLoginErrorCode(parsedError?.response.data.error.code ?? null);
        options.onError?.();
      });
  }, [token, email, setTokens, options]);

  return {
    isLoggingIn,
    loginError,
    loginErrorCode,
    token,
    email,
  };
};
